export default function () {
  return {
    users: [],
    meta: {},
    isFormDialogOpen: false
  };
}